/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Pause2': {
    width: 6,
    height: 8,
    viewBox: '0 0 6 8',
    data: '<path pid="0" d="M2 1a1 1 0 10-2 0v6a1 1 0 002 0V1zM5 0a1 1 0 011 1v6a1 1 0 11-2 0V1a1 1 0 011-1z" _fill="#fff"/>'
  }
})
